// extracted by mini-css-extract-plugin
export default {"ScreenXXSMin":"(min-width: 544px)","ScreenXXSMax":"(max-width: 543px)","hiddenOnMobile":"G46ebdc","visibleOnlyOnMobile":"Gf6e164"};